import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBVisa = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Visa and Indo Zambia Bank Sign Landmark 5-Year Strategic Collaboration to Accelerate Digital Payments in Zambia</h1>

                    <p className="pb-3">Indo Zambia Bank (IZB) has entered into a five-year strategic partnership with Visa to accelerate digital payments adoption and strengthen Zambia’s financial ecosystem.
                    </p>

                    <p className="pb-3">IZB Managing Director, Brajesh K. Singh, described the agreement as a landmark step in advancing Zambia’s digital agenda and expanding financial inclusion. He said the collaboration integrates Visa’s global payment capabilities with the bank’s digital platforms, including the IZB NXT App and Indo Wallet, to deliver faster, more secure, and accessible payment solutions for retail and corporate customers.
                    </p>

                    <p className="pb-3">Visa Country Manager, Amon Magunje, said the collaboration reflects Visa’s long-term confidence in Zambia’s economic potential and commitment to building a resilient, future-ready payments ecosystem. He added that through its global platforms and advanced risk and identity capabilities, Visa will enable Indo Zambia Bank to deliver differentiated payment experiences, drive sustainable growth, and strengthen trust across the financial system.</p>

                    <p className="pb-3">Through this collaboration, Visa and Indo Zambia Bank are positioned to play a defining role in advancing Zambia’s digital payments journey, supporting economic growth, financial inclusion, and the long-term resilience of the national payments’ ecosystem.
                    </p>

                    <p className="pb-3"><b><em>#DigitalPayments #Zambia #Visa #Collaboration #IndoZambiaBank #SupportingYouDevelopingZambia #LetsGrowTogether</em></b></p>

                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark.jpeg" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_1.jpeg" />
                            </div>
                            <div>
                                 <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_2.jpeg" />
                            </div>
                            <div>
                                 <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_3.jpeg" />
                            </div>
                            <div>
                                 <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_4.jpeg" />
                            </div>
                            <div>
                                 <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_5.jpeg" />
                            </div>
                            <div>
                                 <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_6.jpeg" />
                            </div>
                            <div>
                                 <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Visa_and_Indo_Zambia_Bank_Sign_Landmark_7.jpeg" />
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IZBVisa;
